<script>
import { Bar } from "vue-chartjs";
import IndicadoresAPI from "../../../api/indicadores";
import { mapGetters } from "vuex";

export default {
  props: ["ano_corrente", "filial"],
  extends: Bar,
  data: () => ({
    chartdata: {
      labels: [],
      datasets: [],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        mode: "point",
      },
      hover: {
        mode: "index",
      },
      scales: {
        xAxes: [
          {
            stacked: false,
          },
        ],

        yAxes: [
          {
            stacked: false,

            ticks: {
              callback: function (value) {
                var ranges = [
                  { divider: 1e6, suffix: "M" },
                  { divider: 1e3, suffix: "k" },
                  { divider: 1, suffix: " " },
                ];

                var ranges_negativo = [
                  { divider: -1e6, suffix: "M" },
                  { divider: -1e3, suffix: "k" },
                  { divider: -1, suffix: " " },
                ];

                function formatNumber(n) {
                  var i = 0;

                  if (n >= 0) {
                    for (i = 0; i < ranges.length; i++) {
                      if (n >= ranges[i].divider) {
                        return (
                          (n / ranges[i].divider).toString() + ranges[i].suffix
                        );
                      }
                    }
                  } else {
                    for (i = 0; i < ranges_negativo.length; i++) {
                      if (n <= ranges_negativo[i].divider) {
                        return (
                          ((n / ranges_negativo[i].divider) * -1).toString() +
                          ranges_negativo[i].suffix
                        );
                      }
                    }
                  }

                  return n;
                }

                return formatNumber(value);
              },
            },
          },
        ],
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: -10,
          bottom: 15,
        },
      },
      legend: {
        position: "top",
        labels: {
          fontSize: 11,
          padding: 5,
        },
      },
      title: {
        display: true,
        text: "",
        position: "top",
      },
    },
  }),

  watch: {
    grupoCompra() {
      this.montarGrafico();
    },

    ano_corrente: function () {
      this.montarGrafico();
    },

    filial() {
      this.montarGrafico();
    },
  },

  mounted() {
    this.montarGrafico();
  },

  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
  },

  methods: {
    montarGrafico() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        ano: this.ano_corrente,
        grupo: this.grupoCompra,
        filial: this.filial,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        IndicadoresAPI.getStatusEstoqueMensal(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.dados = response.data.indicador.referencia;

              this.chartdata.labels = [];
              this.chartdata.datasets = [];

              this.chartdata.labels = response.data.indicador.referencia;

              //Estoque Itens Novos

              this.chartdata.datasets.push({
                type: "line",
                label: "Estoque Itens Novos",
                backgroundColor: "rgba(1, 87, 155, 0.8)",
                borderColor: "rgba(0,0, 0,0.5)",
                stack: "Stack 0",
                borderWidth: 1,
                pointRadius: 2,

                fill: true,
                data: response.data.indicador.total_estoque_novo,
                datalabels: {
                  anchor: "end",
                  align: "left",
                  display: true,
                  rotation: 360,

                  formatter: function (value) {
                    var ranges = [
                      { divider: 1e6, suffix: "M" },
                      { divider: 1e3, suffix: "k" },
                      { divider: 1, suffix: " " },
                    ];

                    function formatNumber(n) {
                      for (var i = 0; i < ranges.length; i++) {
                        if (n >= ranges[i].divider) {
                          if (ranges[i].divider === 1) {
                            return (
                              (Math.round(n) / ranges[i].divider).toString() +
                              ranges[i].suffix
                            );
                          } else {
                            return (
                              (Math.round(n) / ranges[i].divider)
                                .toFixed(2)
                                .toString() + ranges[i].suffix
                            );
                          }
                        }
                      }
                      return null;
                    }

                    return formatNumber(value);
                  },
                },
              });

              //Estoque Residual

              this.chartdata.datasets.push({
                type: "line",
                label: "Estoque Residual",
                backgroundColor: "rgba(201, 194, 193,1)",
                borderColor: "rgba(0,0, 0,0.5)",
                stack: "Stack 0",
                borderWidth: 1,
                pointRadius: 2,

                fill: true,
                data: response.data.indicador.total_estoque_residual,
                datalabels: {
                  anchor: "center",
                  align: "left",
                  display: true,
                  rotation: 360,

                  formatter: function (value) {
                    var ranges = [
                      { divider: 1e6, suffix: "M" },
                      { divider: 1e3, suffix: "k" },
                      { divider: 1, suffix: " " },
                    ];

                    function formatNumber(n) {
                      for (var i = 0; i < ranges.length; i++) {
                        if (n >= ranges[i].divider) {
                          if (ranges[i].divider === 1) {
                            return (
                              (Math.round(n) / ranges[i].divider).toString() +
                              ranges[i].suffix
                            );
                          } else {
                            return (
                              (Math.round(n) / ranges[i].divider)
                                .toFixed(2)
                                .toString() + ranges[i].suffix
                            );
                          }
                        }
                      }
                      return null;
                    }

                    return formatNumber(value);
                  },
                },
              });

              //Estoque Ideal

              this.chartdata.datasets.push({
                type: "line",
                label: "Estoque Ideal",
                backgroundColor: "rgba(45, 115, 53)",
                borderColor: "rgba(45, 115, 53,0.7)",

                borderWidth: 1.5,
                pointRadius: 2,

                fill: false,
                data: response.data.indicador.total_estoque_ideal,
                datalabels: {
                  anchor: "end",
                  align: "left",
                  display: true,
                  rotation: 360,

                  formatter: function (value) {
                    var ranges = [
                      { divider: 1e6, suffix: "M" },
                      { divider: 1e3, suffix: "k" },
                      { divider: 1, suffix: " " },
                    ];

                    function formatNumber(n) {
                      for (var i = 0; i < ranges.length; i++) {
                        if (n >= ranges[i].divider) {
                          if (ranges[i].divider === 1) {
                            return (
                              (Math.round(n) / ranges[i].divider).toString() +
                              ranges[i].suffix
                            );
                          } else {
                            return (
                              (Math.round(n) / ranges[i].divider)
                                .toFixed(2)
                                .toString() + ranges[i].suffix
                            );
                          }
                        }
                      }
                      return null;
                    }

                    return formatNumber(value);
                  },
                },
              });

              //Estoque Total

              this.chartdata.datasets.push({
                type: "line",
                label: "Estoque Total",
                backgroundColor: "rgba(252, 186, 3,0.7)",
                borderColor: "rgba(252, 186, 3,0.7)",
                stack: "Stack 0",
                borderWidth: 1,
                pointRadius: 2,

                fill: true,
                data: response.data.indicador.total_estoque_real,
                datalabels: {
                  anchor: "end",
                  align: "left",
                  display: true,
                  rotation: 360,

                  formatter: function (value) {
                    var ranges = [
                      { divider: 1e6, suffix: "M" },
                      { divider: 1e3, suffix: "k" },
                      { divider: 1, suffix: " " },
                    ];

                    function formatNumber(n) {
                      for (var i = 0; i < ranges.length; i++) {
                        if (n >= ranges[i].divider) {
                          if (ranges[i].divider === 1) {
                            return (
                              (Math.round(n) / ranges[i].divider).toString() +
                              ranges[i].suffix
                            );
                          } else {
                            return (
                              (Math.round(n) / ranges[i].divider)
                                .toFixed(2)
                                .toString() + ranges[i].suffix
                            );
                          }
                        }
                      }
                      return null;
                    }

                    return formatNumber(value);
                  },
                },
              });

              //Estoque Necessidade

              this.chartdata.datasets.push({
                type: "line",
                label: "Estoque Necessidade",
                backgroundColor: "rgba(214, 14, 43,1)",
                borderColor: "rgba(214, 14, 43,0.5)",
                stack: "Stack 0",
                borderWidth: 1,
                pointRadius: 2,

                fill: true,
                data: response.data.indicador.total_estoque_necessidade,
                datalabels: {
                  anchor: "center",
                  align: "left",
                  display: true,
                  rotation: 360,

                  formatter: function (value) {
                    var ranges = [
                      { divider: 1e6, suffix: "M" },
                      { divider: 1e3, suffix: "k" },
                      { divider: 1, suffix: " " },
                    ];

                    function formatNumber(n) {
                      let i;

                      for (i = 0; i < ranges.length; i++) {
                        if (Math.abs(n) >= ranges[i].divider) {
                          if (ranges[i].divider === 1) {
                            return (
                              (Math.round(n) / ranges[i].divider).toString() +
                              ranges[i].suffix
                            );
                          } else {
                            return (
                              (Math.round(n) / ranges[i].divider)
                                .toFixed(2)
                                .toString() + ranges[i].suffix
                            );
                          }
                        }
                      }
                      return null;
                    }

                    return formatNumber(value);
                  },
                },
              });

              this.renderChart(this.chartdata, this.options);
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
  },
};
</script>

